import { Container, Row, Col, Image } from 'react-bootstrap'
import Link from 'next/link'
import { Request } from '@group-devs/yfp7-global-modules'
const request = new Request(process.env.apiDomain)

const ConfirmHeader = (props) => {
    const url = process.env.backofficeDomain;

    const accountId = props.props.site.accountId;
    const { data: profile  } = request.account.swrAccountProfile(accountId)
    const user_id = profile ? parseInt(profile.user.id) : '';
    const url7bs = 'https://'+props.props.site.url

    return (
        <>
        <div className="section-confirmation-header">
            <Container>
                <h1>CONGRATULATIONS!</h1>
                <p>On Taking Your First Step!</p>
                <p>Now: click to Download your FREE REPORT</p>
                <Row>
                    <Col md={7}>
                        <div className="input-group download-the-ebook">
                            <span className="input-group-addon" id="basic-addon1">
                                <Link href={url + "website/ebook/7bs?user_id="+user_id+"&download=true"}><a>
                                    <Image src="../images/7bs/img-7bs-download01.png" alt="Download"/>
                                </a></Link>
                            </span>
                            <div className="form-control">
                                <p>
                                    <a href={url + "website/ebook/7bs?user_id="+user_id+"&download=true"} className=""><strong>DOWNLOAD THE E-BOOK</strong></a>
                                </p>
                            </div>
                        </div>
                        <div className="input-group share-this">
                            <span className="input-group-addon" id="basic-addon1">
                                <Image src="../images/7bs/img-7bs-share01.png" alt="Share"/>
                            </span>
                            <div className="form-control"><p><strong>SHARE THIS</strong></p></div>
                        </div>
                        <div className="form-control share-icons">
                            <span className="facebook-icon"><Link href={"https://www.facebook.com/sharer/sharer.php?u="+url7bs} passHref><a target="_blank"><Image src="../images/7bs/img-7bs-facebook01.png"/></a></Link></span>
                            <span className="twitter-icon"><Link href={"https://twitter.com/intent/tweet?url="+url7bs+"&text=The 7 Big Secrets to Losing Weight %0A"} passHref><a target="_blank"><Image src="../images/7bs/img-7bs-twitter01.png"/></a></Link></span>
                        </div>
                    </Col>
                </Row>
                <Image src="../images/7bs/bg-smoothee-fruits01.png" alt="Download Ebook" className="img-fluid ebook"/>
            </Container>
        </div>
        <style jsx global>{`

                .section-confirmation-header {
                    background: #f6f6f6;
                }

                .section-confirmation-header .container {
                    padding-top: 110px;
                    padding-bottom: 200px;
                    position: relative;
                }

                .section-confirmation-header h1 {
                    font-size: 54px;
                    color: #de7621;
                    font-weight: 700;
                    margin-bottom: 40px;
                }

                .section-confirmation-header .download-the-ebook {    
                    margin-top: 20px;
                    margin-bottom: 20px;
                    font-size: 18px;
                    line-height: 30px;
                }

                .section-confirmation-header .download-the-ebook .input-group-addon {    
                    background-color: #fdd051;
                    color: #000;
                    padding: 15px;
                }

                .section-confirmation-header .download-the-ebook .form-control {    
                    padding: 29px;
                    font-size: 15px;
                    max-width: 310px;
                    background: #444951;
                    color: #fff;
                }

                .section-confirmation-header .download-the-ebook .form-control p {    
                    margin-top: -13px;
                    font-size: 20px;
                }

                .section-confirmation-header .download-the-ebook .form-control a {    
                    color:#fff !important;
                    text-decoration: none;
                }

                .section-confirmation-header .share-icons {    
                    margin-top: -27px;
                    max-width: 244px;
                    padding-bottom: 45px;
                    padding-top: 15px;
                    padding-left: 30px;
                    background: #E5E5E5;
                }

                .section-confirmation-header .share-icons a {    
                    color: #fff !important;
                }

                .section-confirmation-header .share-icons .facebook-icon,
                .section-confirmation-header .share-icons .twitter-icon {    
                    padding-right: 30px;
                }

                .section-confirmation-header .share-this {
                    margin-bottom: 20px;
                    font-size: 18px;
                    line-height: 30px;
                }

                .section-confirmation-header .share-this .input-group-addon {
                    background: #fdd051;
                    color: #000;
                    padding: 15px;
                }

                .section-confirmation-header .share-this .form-control {
                    padding: 31px;
                    font-size: 15px;
                    max-width: 185px;
                    background: #F86052;
                    color: #fff;
                }

                .section-confirmation-header .share-this .form-control p {    
                    margin-top: -13px;
                    font-size: 20px;
                }

                .section-confirmation-header .ebook {    
                    position: absolute;
                    bottom: 50px;
                    right: 0px;
                    width: 50%;
                }

                @media (max-width: 767.98px) {	

                    .section-confirmation-header .container {
                        padding-top: 50px;
                        padding-bottom: 0px;
                    }

                    .section-confirmation-header h1 {
                        font-size: 42px;
                    }
    	
                    .section-confirmation-header .ebook {    
                        position: relative;
                        bottom: auto;
                        right: auto;
                        width: 100%;
                    }

                }

            `}</style>
        </>
    )
}

export default ConfirmHeader;